import React from "react";

const ContributionSkeleton: React.FC = () => {
  return (
    <div className="animate-pulse">
      {/* Employer max contribution section */}
      <div className="p-[32px] flex justify-between items-center">
        <div>
          <div className="h-4 bg-gray-200 rounded w-64 mb-2"></div>
          <div className="flex space-x-1 items-center">
            <div className="h-5 bg-gray-200 rounded w-8"></div>
            <div className="h-4 w-4 bg-gray-200 rounded-full"></div>
          </div>
        </div>
      </div>
      <hr />

      {/* Beneficiary contribution section */}
      <div className="p-[32px]">
        <div className="space-y-2">
          <div className="h-5 bg-gray-200 rounded w-32 mb-4"></div>
          <div className="space-y-1">
            <div className="flex justify-between">
              <div className="h-4 bg-gray-200 rounded w-28"></div>
              <div className="h-4 bg-gray-200 rounded w-12"></div>
            </div>
            <div className="flex justify-between">
              <div className="h-4 bg-gray-200 rounded w-32"></div>
              <div className="h-4 bg-gray-200 rounded w-14"></div>
            </div>
            <div className="flex justify-between">
              <div className="h-4 bg-gray-200 rounded w-28"></div>
              <div className="h-4 bg-gray-200 rounded w-16"></div>
            </div>
          </div>
        </div>
      </div>
      <hr />

      {/* Summary section */}
      <div className="bg-[#F9F9F9]">
        <div className="p-[32px] space-y-1 border-t">
          <div className="flex justify-between">
            <div className="flex space-x-1 items-center">
              <div className="h-4 bg-gray-200 rounded w-32"></div>
              <div className="h-4 w-4 bg-gray-200 rounded-full"></div>
            </div>
            <div className="h-4 bg-gray-200 rounded w-12"></div>
          </div>
          <div className="flex justify-between">
            <div className="flex space-x-1 items-center">
              <div className="h-4 bg-gray-200 rounded w-28"></div>
              <div className="h-4 w-4 bg-gray-200 rounded-full"></div>
            </div>
            <div className="h-4 bg-gray-200 rounded w-14"></div>
          </div>
          <div className="flex justify-between">
            <div className="h-4 bg-gray-200 rounded w-36"></div>
            <div className="h-4 bg-gray-200 rounded w-16"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContributionSkeleton;
